import ShowModulePercentage from '../ShowModulePercentage';

const ModuleCardStats = ({ showCompleteness, completenessPercent, showRisk, riskPercent, isInvestorMatch, strongMatchCount, mediumMatchCount }) => {
    if (isInvestorMatch) {
        return (
            <div className='df aic' style={{ gap: '0.25rem' }}>
                <h4 className={`${strongMatchCount > 0 ? 'green' : 'c28'} fs2rem lh1 mr2rem`}>
                    {strongMatchCount || 0}<br />
                    <span className={`${strongMatchCount > 0 ? 'c15' : 'c15'} fs0-75rem w4rem db fw300`}>Strong Match</span>
                </h4>
                <h4 className={`${mediumMatchCount > 0 ? 'yellow' : 'c28'} fs2rem lh1 mr2rem`}>
                    {mediumMatchCount || 0}<br />
                    <span className={`${mediumMatchCount > 0 ? 'c15' : 'c15'} fs0-75rem w4rem db fw300`}>Medium Match</span>
                </h4>
            </div>
        );
    }
    return (
        <div className='df aic' style={{ gap: '0.25rem' }}>
            {showCompleteness && (
                <ShowModulePercentage value={completenessPercent} type="Module Complete" />
            )}
            {showRisk && (
                <ShowModulePercentage value={riskPercent} type="Module Risk" />
            )}
        </div>
    );
};

export default ModuleCardStats;
